<template>
  <div class="row">
    <div class="col-1 m-0"></div>
    <div class="col-11 m-0 position-relative input-col-10-padding" :data-bs-toggle="'modal'"
         :data-bs-target="'#picker-frequency'">
        <input class="custom-select-frequency"
               id="picker-frequency-date"
               placeholder="Pasirinkite kelionės dažnumą"/>
        <div class="arrow-select position-absolute icon-calender-position">
          <img src="/assets/images/calendar-calendar-1.svg">
        </div>
    </div>
  </div>
  <ModalComponent :id-data="'picker-frequency'" :modal-title="'Pasirinkite kelionės dažnumą'">
    <template #body-content>
      <div class="modal-calendar-container d-flex justify-content-around">
        <div id="date-picker-date-1" class="">
          <Datepicker v-model="date1"
                      :enableTimePicker="false"
                      monthNameFormat="long"
                      :locale="store.state.general.locale"
                      inline
                      autoApply
                      id="picker-1"
                      ref="datepicker-1"/>
        </div>
        <div id="date-picker-date-2" class="">
          <Datepicker v-model="date2"
                      :enableTimePicker="false"
                      monthNameFormat="long"
                      :locale="store.state.general.locale"
                      inline
                      autoApply
                      id="picker-2"
                      ref="datepicker-2"/>
        </div>
      </div>

    </template>
  </ModalComponent>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import './customRouteFrequencySelect.scss';
// @ts-ignore
import DatePickerComponent from "../Datepicker/DatePickerComponent.vue";
import Datepicker from '@vuepic/vue-datepicker';
import {useStore} from "vuex";
// @ts-ignore
import ModalComponent from "../modal/ModalComponent.vue";

export default defineComponent({
  name: 'CustomRouteFrequencySelectComponent',
  components: {
    ModalComponent,
    Datepicker,
    DatePickerComponent
  },
  props: {},

  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {
      date1: null,
      date2: null
    };
  },

  mounted() {
    let modal = document.querySelector('#picker-frequency');
    // @ts-ignore
    let modaldialog = modal.querySelector('.modal-dialog');
    // @ts-ignore
    let header = modal.querySelector('.modal-header');
    // @ts-ignore
    header.classList.add('d-flex');
    // @ts-ignore
    header.classList.add('justify-content-center');
    // @ts-ignore
    header.classList.add('modal-header-border');


    // @ts-ignore
    modaldialog.classList.remove('modal-xl');


  }
})
</script>
